import React from 'react'
import styled from '@emotion/styled'
import type * as CSS from 'csstype'
import _ from 'lodash'
import L1Tip from './L1Tip'

interface L1TitleRootProps {
	print: boolean
}

interface L1Title3RootProps {
	fontSize?: string|number,
	fontWeight?: string|number,
	textTransform?: CSS.Property.TextTransform,
}

const L1Title1Root = styled.div<L1TitleRootProps>(({theme, print}) => ({
	display: 'flex',
	flexDirection: 'row',
	backgroundColor: print ? theme.colors.pdfGray : theme.colors.second,
	borderRadius: print ? theme.borderRadius : 'initial',
	padding: print ? theme.spacing(2) : theme.spacing(2.5, 6.5, 2.5, 6),
	color: print ? theme.colors.black : theme.colors.blueMain,
	...theme.fonts.titleBold,
	alignItems: 'center',
	fontSize: '18px',
	fontWeight: 700,
	textTransform: 'uppercase',
	marginTop: theme.spacing(2),
	marginBottom: theme.spacing(6),
	'&:first-of-type': {
		marginTop: 0,
	},
}))

const L1Title2Root = styled.div<L1TitleRootProps>(({theme, print}) => ({
	display: 'flex',
	flexDirection: 'row',
	backgroundColor: print ? theme.colors.pdfGray : theme.colors.miniHeader,
	borderRadius: theme.borderRadius,
	padding: theme.spacing(1, 2),
	color: print ? theme.colors.black : theme.colors.white,
	...theme.fonts.titleBold,
	fontSize: '14px',
	fontWeight: 700,
	textTransform: 'uppercase',
}))

const L1Title3Root = styled.div<L1Title3RootProps>(({theme, fontSize = '16px', fontWeight = 600, textTransform = 'uppercase'}) => ({
	fontSize,
	fontWeight,
	textTransform
}))

type L1TitleProps = {
	title?: string,
	tier?: number,
	titleStyle?: any,
	print?: boolean,
	required?: boolean,
}

const L1Title = ({title, tier = 3, titleStyle = {}, print = false, required}: L1TitleProps) => {
	let Component

	if(!_.isNumber(tier)) {
		tier = parseInt(tier)
	}

	switch(tier) {
		case 1:
			Component = L1Title1Root
			break
		case 2:
			Component = L1Title2Root
			break
		default:
			Component = L1Title3Root
	}
	return (
		<Component print={print}>
			<div style={titleStyle}>
				{
					required && <L1Tip icon="error" tip={`${title} is required.`} leftPad={false} />
				}
				{title}
			</div>
		</Component>
	)
}

export default L1Title
